export const MOBILE_WIDTH = 575;
export const SEMANTIC_TYPES = [
    {
        semanticType: "PHONE_NUMBER",
        id:"phone-num-id",
        label: "phone-num-label",
        inputId: "phone-num-input",
        subQuestionLabel: "new-phone-num-label",
        errorId: "err-help-phone",
        errorMessage: "Enter a valid phone number"
    },
    {
        semanticType: "GATED",
        id: "gate-id",
        label: "gated-label",
        inputId: "gate-code-input",
        subQuestionLabel: "entrance-label",
        errorId: "err-help-gated",
        errorMessage: ""
    },
    {
        semanticType: "GATE_PASS_CODE",
        id: "gate-pass-code-id",
        label: "gated-pass-code-label",
        inputId: "gate-code-input",
        subQuestionLabel: "gated-pass-code-label",
        errorId: "err-help-gate-code",
        errorMessage: "Enter a valid gate code"
    },
    {
        semanticType: "NEWLY_BUILT",
        id: "newly-built-id",
        label: "newly-built-label",
        inputId: "street-name-input",
        subQuestionLabel: "street-name-label",
        errorId: "err-help-street",
        errorMessage: "Enter a valid street address"
    },
    {
        semanticType: "TRUCK",
        id: "delivery-truck-id",
        label: "delivery-truck-label",
        inputId: "delivery-truck-input",
        subQuestionLabel: "delivery-truck-label",
        errorId: "",
        errorMessage: ""
        
    },
    {
        semanticType: "REPLACEMENT",
        id: "replacement-id",
        label: "replacement-label",
        inputId: "replacement-input",
        subQuestionLabel: "replacement-label",
        errorId: "",
        errorMessage: ""
    },
    {
        semanticType: "REPLACEMENT_ITEM",
        id: "replacement-id",
        label: "replacement-label",
        inputId: "replacement-input",
        subQuestionLabel: "replacement-label",
        errorId: "",
        errorMessage: ""
    },
    {
        semanticType: "HAUL_AWAY",
        id: "haul-away-id",
        label: "haul-away-label",
        inputId: "haul-away-input",
        subQuestionLabel: "haul-away-label",
        errorId: "",
        errorMessage: ""
    },
    {
        semanticType: "HAUL_AWAY_ITEM",
        id: "haul-away-id",
        label: "haul-away-label",
        inputId: "haul-away-input",
        subQuestionLabel: "haul-away-label",
        errorId: "",
        errorMessage: ""
    },
    {
        semanticType: "HAUL_AWAY_BULK",
        id: "haul-away-id",
        label: "haul-away-label",
        inputId: "haul-away-input",
        subQuestionLabel: "haul-away-label",
        errorId: "",
        errorMessage: ""
    },
    {
        semanticType: "REVERSE_DOOR",
        id: "reverse-door-id",
        label: "reverse-door-label",
        inputId: "reveres-door-input",
        subQuestionLabel: "reverse-door-label",
        errorId: "",
        errorMessage: ""
    },
    {
        semanticType: "SHUT_OFF_VALVE",
        id: "shut-off-valve-id",
        label: "shut-off-valve-label",
        inputId: "shut-off-valve-input",
        subQuestionLabel: "shut-off-valve-label",
        errorId: "",
        errorMessage: ""
    }
];
export const ADOBE_MESSAGES = {
    schedule_page_name: "Schedule My Delivery",
    scheduler_landing_section: "Landing Page",
    scheduler_bulk_section: "Bulk Page",
    scheduler_calendar_section: "Calendar Page",
    scheduler_qna_section: "Questionnaire Page",
    scheduler_review_section: "Review Page",
    scheduler_confirmation_section: "Confirmation Page",
    tracking_page_name: "Track My Delivery",
    home_page_name: "Home Page",
    button_click_landing: "Landing Page",
    button_click_bulk: "Bulk Selection Page",
    button_click_calendar: "Calendar Page",
    button_click_qna: "Questions Page",
    button_click_review: "Review Page",
    button_click_incorrect_info: "Incorrect Information Cancel",
    button_click_tracking: "Tracking Page",
    no_service_ui_message: "No Service",
    no_records_message: "No Records Found"
};